module.exports = __webpack_public_path__ + "img/mongolia.67b39abe.png";